/* accessibility-patches.js
   Global, theme-update-safe accessibility patches for fifteen52 (Shopify Symmetry)
*/

(function () {
  // Run once DOM is ready
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  // Add aria-label only if neither aria-label nor aria-labelledby exists
  function setAriaLabelIfMissing(el, label) {
    if (!el) return;
    if (!el.hasAttribute("aria-label") && !el.hasAttribute("aria-labelledby")) {
      el.setAttribute("aria-label", label);
    }
  }

  // Ensure a unique id for an element
  function ensureUniqueId(el, preferredId) {
    if (!el) return "";
    var base = preferredId || "a11y-id";
    if (!el.id) {
      el.id = base + "-" + Math.random().toString(36).slice(2, 10);
      return el.id;
    }

    // If current id is unique, keep it
    var existing = document.querySelectorAll("#" + CSS.escape(el.id));
    if (existing.length <= 1) return el.id;

    // Otherwise make it unique
    var i = 2;
    var next = base + "-" + i;
    while (document.getElementById(next)) {
      i += 1;
      next = base + "-" + i;
    }
    el.id = next;
    return el.id;
  }

  // Ensure visually-hidden class exists (used for labels)
  function ensureVisuallyHiddenCss() {
    if (document.getElementById("a11y-visually-hidden-style")) return;
    var style = document.createElement("style");
    style.id = "a11y-visually-hidden-style";
    style.textContent =
      ".visually-hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;}";
    document.head.appendChild(style);
  }

  // 1) Footer localization and newsletter form labels/ids
  function patchFooterForms() {
    // Footer localization form
    var footerLoc = document.getElementById("footer-localization");
    if (footerLoc) {
      ensureUniqueId(footerLoc, "footer-localization");
      setAriaLabelIfMissing(footerLoc, "Footer localization");
    }

    // Footer newsletter form (scope to footer only)
    var footer =
      document.getElementById("pagefooter") ||
      document.querySelector("footer") ||
      document;

    var newsletterForm =
      footer.querySelector('form.contact-form#contact_form') ||
      footer.querySelector('form.contact-form[action^="/contact"]');

    if (newsletterForm) {
      ensureUniqueId(newsletterForm, "footer-newsletter-form");
      setAriaLabelIfMissing(newsletterForm, "Footer newsletter signup");
    }

    // Any other localization forms
    document.querySelectorAll("form.localization").forEach(function (form) {
      setAriaLabelIfMissing(form, "Localization");
    });
  }

  // 2) YouTube embeds: ensure iframe has a title
  function patchYouTubeIframes(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]'
      )
      .forEach(function (iframe) {
        if (!iframe.getAttribute("title")) {
          iframe.setAttribute("title", "YouTube video");
        }
      });
  }

  // 3) Remove invalid listitem roles from anchors (legacy markup)
  function patchInvalidAnchorRoles(root) {
    var scope = root || document;
    scope.querySelectorAll('a[role="listitem"]').forEach(function (a) {
      a.removeAttribute("role");
    });
  }

  // 4) Fix "hidden but focusable" blog links: aria-hidden="true" on <a>
  function fixAriaHiddenLinks(root) {
    if (!root || !root.querySelectorAll) return;

    var links = root.querySelectorAll('a.small-feature-link[aria-hidden="true"]');

    links.forEach(function (a) {
      // Remove aria-hidden so it is not hidden but focusable
      a.removeAttribute("aria-hidden");

      // If it is generic "Read more", give it a better label
      var text = (a.textContent || "").trim().toLowerCase();
      if (!a.getAttribute("aria-label") && (text === "read more" || text === "readmore")) {
        var card =
          a.closest(
            "article, .article, .blog-article, .featured-blog__article, .feature, .grid-item, .card"
          ) || a.parentElement;

        var titleEl =
          card &&
          card.querySelector(
            "h1, h2, h3, .h1, .h2, .h3, .title, .article-title, .blog-title, a[href*='/blogs/']"
          );

        var title = titleEl ? (titleEl.textContent || "").trim() : "";
        a.setAttribute("aria-label", title ? "Read more: " + title : "Read more");
      }
    });
  }

  // 5) Quantity input: ensure a visible-label association exists (hidden label is fine)
  // AAArdvark flagged: "input does not have an associated visible label"
  function addQuantityLabel(root) {
    var scope = root || document;

    // Your console test confirmed: input[name="quantity"] exists.
    var inputs = scope.querySelectorAll('input[name="quantity"], input[aria-label="Quantity"]');

    inputs.forEach(function (input) {
      // Avoid repeated work
      if (input.dataset.a11yQtyLabeled === "1") return;

      // If there is already a <label for="...">, stop
      if (input.labels && input.labels.length > 0) {
        input.dataset.a11yQtyLabeled = "1";
        return;
      }

      // Ensure unique id
      var id = input.id || ("quantity-" + Math.random().toString(36).slice(2, 8));
      input.id = id;

      // If label exists in this scope or document, stop
      var existingLabel =
        scope.querySelector('label[for="' + CSS.escape(id) + '"]') ||
        document.querySelector('label[for="' + CSS.escape(id) + '"]');

      if (existingLabel) {
        input.dataset.a11yQtyLabeled = "1";
        return;
      }

      // Create hidden label and insert before input
      var label = document.createElement("label");
      label.setAttribute("for", id);
      label.className = "visually-hidden";
      label.textContent = "Quantity";
      input.parentNode.insertBefore(label, input);

      input.dataset.a11yQtyLabeled = "1";
    });
  }

  // Observe DOM changes once, then run targeted patches on added nodes
  function observeDynamicRenders() {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes) continue;

        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          // Run patches that matter for dynamic content
          patchYouTubeIframes(node);
          patchInvalidAnchorRoles(node);
          fixAriaHiddenLinks(node);
          addQuantityLabel(node);
        });
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Boot
  onReady(function () {
    ensureVisuallyHiddenCss();

    patchFooterForms();
    patchYouTubeIframes(document);
    patchInvalidAnchorRoles(document);
    fixAriaHiddenLinks(document);
    addQuantityLabel(document);

    observeDynamicRenders();
  });
})();

/* XO Gallery: ensure filter <select> has an accessible name (label) */
(function () {
  'use strict';

  function ensureId(el, prefix) {
    if (!el) return '';
    if (el.id) return el.id;
    el.id = (prefix || 'xo-select') + '-' + Math.random().toString(36).slice(2, 9);
    return el.id;
  }

  function setLabelForSelect(selectEl) {
    if (!selectEl) return;

    // If XO already fixed it, do nothing.
    if (selectEl.hasAttribute('aria-label') || selectEl.hasAttribute('aria-labelledby')) return;

    // Try to bind to an existing visible label in the XO filter UI.
    // Common patterns: a text node or element near the select that reads "Search by Model".
    var container =
      selectEl.closest('.xo-filter') ||
      selectEl.closest('.xo-gallery') ||
      selectEl.parentElement;

    if (container) {
      var possibleLabelEls = container.querySelectorAll('label, .xo-filter__label, .xo-filter-label, [class*="label"]');
      for (var i = 0; i < possibleLabelEls.length; i++) {
        var lbl = possibleLabelEls[i];
        var txt = (lbl.textContent || '').trim();
        if (!txt) continue;

        // If the visible text clearly describes the dropdown, link it.
        // This catches “Search by Model” and similar strings.
        if (/search\s*by\s*model/i.test(txt) || /model/i.test(txt)) {
          var lblId = ensureId(lbl, 'xo-filter-label');
          selectEl.setAttribute('aria-labelledby', lblId);
          return;
        }
      }
    }

    // Fallback: just name it.
    selectEl.setAttribute('aria-label', 'Search by model');
  }

  function run() {
    // Your scan points to: <select class="xo-filter__dropdown">
    var selects = document.querySelectorAll('select.xo-filter__dropdown');
    for (var i = 0; i < selects.length; i++) setLabelForSelect(selects[i]);
  }

  // Run now.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // XO often injects UI after load. Watch for new nodes and re-run.
  var mo = new MutationObserver(function () { run(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  'use strict';

  function ensureId(el, prefix) {
    if (!el) return '';
    if (el.id) return el.id;
    el.id = (prefix || 'xo-el') + '-' + Math.random().toString(36).slice(2, 9);
    return el.id;
  }

  function ensureSrOnlyStyles() {
    if (document.getElementById('a11y-sr-only-style')) return;
    var style = document.createElement('style');
    style.id = 'a11y-sr-only-style';
    style.textContent =
      '.a11y-sr-only{' +
      'position:absolute!important;' +
      'width:1px!important;' +
      'height:1px!important;' +
      'padding:0!important;' +
      'margin:-1px!important;' +
      'overflow:hidden!important;' +
      'clip:rect(0,0,0,0)!important;' +
      'white-space:nowrap!important;' +
      'border:0!important;' +
      '}';
    document.head.appendChild(style);
  }

  function getLabelText(selectEl) {
    // If there is visible text near it, prefer that.
    var scope =
      selectEl.closest('.xo-filter') ||
      selectEl.closest('.xo-gallery') ||
      selectEl.closest('[class*="xo"]') ||
      selectEl.parentElement;

    if (!scope) return 'Search by model';

    var nodes = scope.querySelectorAll('label, [class*="label"], [class*="title"], [class*="heading"]');
    for (var i = 0; i < nodes.length; i++) {
      var t = (nodes[i].textContent || '').trim();
      if (!t) continue;
      if (/search\s*by\s*model/i.test(t)) return 'Search by model';
      if (/model/i.test(t)) return 'Model';
    }

    return 'Search by model';
  }

  function fixSelect(selectEl) {
    if (!selectEl) return;

    // If it already has a native label association, leave it alone.
    var id = ensureId(selectEl, 'xo-filter-select');
    var existingLabel = document.querySelector('label[for="' + CSS.escape(id) + '"]');
    if (existingLabel) return;

    ensureSrOnlyStyles();

    // Create a hidden label right before the select
    var label = document.createElement('label');
    label.className = 'a11y-sr-only';
    label.htmlFor = id;
    label.textContent = getLabelText(selectEl);

    selectEl.parentNode.insertBefore(label, selectEl);

    // Belt and suspenders for scanners
    selectEl.setAttribute('aria-label', label.textContent);
  }

  function runOnce() {
    var selects = document.querySelectorAll(
      'select.xo-filter__dropdown, select[class*="xo-filter"][class*="dropdown"], select[class*="xo"][class*="filter"]'
    );
    for (var i = 0; i < selects.length; i++) fixSelect(selects[i]);
    return selects.length;
  }

  function boot() {
    runOnce();

    // Retry for late-injected UI
    var tries = 0;
    var maxTries = 20; // 10s
    var t = setInterval(function () {
      tries++;
      runOnce();
      if (tries >= maxTries) clearInterval(t);
    }, 500);

    var mo = new MutationObserver(function () { runOnce(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* Signifyd hidden iframe: give it a meaningful title to satisfy a11y scanners */
(function () {
  'use strict';

  function isSignifydIframe(el) {
    if (!el || el.tagName !== 'IFRAME') return false;

    var src = el.getAttribute('src') || '';
    var id = el.id || '';

    // Host match or known id prefix
    if (src.indexOf('signifyd.com') !== -1) return true;
    if (id.indexOf('tdr_') === 0) return true;

    return false;
  }

  function fixIframe(el) {
    if (!isSignifydIframe(el)) return;

    var title = (el.getAttribute('title') || '').trim().toLowerCase();
    if (!title || title === 'empty') {
      el.setAttribute('title', 'Fraud prevention verification (hidden)');
    }

    // Ensure it stays out of the tab order
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    // Some scanners like explicit aria-hidden on hidden tracking iframes
    if (!el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
  }

  function run() {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) fixIframe(iframes[i]);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Watch for reinjection
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m.addedNodes || !m.addedNodes.length) continue;

      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (!node) continue;

        if (node.tagName === 'IFRAME') {
          fixIframe(node);
        } else if (node.querySelectorAll) {
          var nested = node.querySelectorAll('iframe');
          for (var k = 0; k < nested.length; k++) fixIframe(nested[k]);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* A11y patch: normalize hidden/1x1 tracking iframes so scanners stop flagging them */
(function () {
  'use strict';

  function isEffectivelyHiddenFrame(f) {
    if (!f || f.tagName !== 'IFRAME') return false;

    // Explicitly hidden from AT
    if ((f.getAttribute('aria-hidden') || '').toLowerCase() === 'true') return true;

    // Explicitly non-focusable
    if ((f.getAttribute('tabindex') || '') === '-1') {
      // Many trackers also set 0x0
      var w = parseInt(f.getAttribute('width') || '0', 10);
      var h = parseInt(f.getAttribute('height') || '0', 10);
      if ((w === 0 && h === 0) || (w === 1 && h === 1)) return true;
    }

    // CSS-hidden
    var cs;
    try { cs = window.getComputedStyle(f); } catch (e) { cs = null; }
    if (cs) {
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return true;

      // Position off-screen or zero-sized
      var rect = f.getBoundingClientRect();
      if ((rect.width <= 1 && rect.height <= 1) || rect.bottom < 0 || rect.right < 0) return true;
    }

    // HTML hidden attribute
    if (f.hasAttribute('hidden')) return true;

    return false;
  }

  function getHost(src) {
    try { return new URL(src, window.location.href).hostname; } catch (e) { return ''; }
  }

  function makeTitle(host, src) {
    if (host) return 'Embedded content from ' + host + ' (hidden)';
    if (src) return 'Embedded content (hidden)';
    return 'Embedded content (hidden)';
  }

  function fixFrame(f) {
    if (!f || f.tagName !== 'IFRAME') return;

    if (!isEffectivelyHiddenFrame(f)) return;

    // Give hidden iframes a meaningful title, only when missing or junk
    var t = (f.getAttribute('title') || '').trim();
    var tl = t.toLowerCase();

    if (!t || tl === 'empty' || tl === 'iframe' || tl === 'frame' || tl === 'tracking') {
      var src = (f.getAttribute('src') || '').trim();
      var host = getHost(src);
      f.setAttribute('title', makeTitle(host, src));
    }

    // Ensure it stays out of keyboard flow
    if (!f.hasAttribute('tabindex')) f.setAttribute('tabindex', '-1');

    // If it is effectively hidden, keep it out of the accessibility tree
    if (!f.hasAttribute('aria-hidden')) f.setAttribute('aria-hidden', 'true');
  }

  function runAll() {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) fixFrame(iframes[i]);
  }

  function boot() {
    runAll();

    // Retry loop for late injected tags (10 seconds)
    var tries = 0;
    var maxTries = 20; // 20 * 500ms = 10s
    var timer = setInterval(function () {
      tries++;
      runAll();
      if (tries >= maxTries) clearInterval(timer);
    }, 500);

    // Mutation observer for ongoing injections
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node) continue;

          if (node.tagName === 'IFRAME') {
            fixFrame(node);
          } else if (node.querySelectorAll) {
            var nested = node.querySelectorAll('iframe');
            for (var k = 0; k < nested.length; k++) fixFrame(nested[k]);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* A11y patch: give each footer navigation landmark a unique accessible name */
(function () {
  'use strict';

  function ensureId(el, prefix) {
    if (!el) return '';
    if (el.id) return el.id;
    el.id = (prefix || 'a11y') + '-' + Math.random().toString(36).slice(2, 9);
    return el.id;
  }

  function normalizeText(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  function findFooterNavs() {
    // Symmetry footer commonly uses these patterns
    var footer = document.querySelector('#shopify-section-sections--17685821685826__footer, footer');
    if (!footer) return [];
    return Array.from(footer.querySelectorAll('nav,[role="navigation"]'));
  }

  function findBlockHeading(navEl) {
    // Look within the same footer column/block
    var block =
      navEl.closest('.section-footer__row__col') ||
      navEl.closest('.section-footer__menu-block') ||
      navEl.parentElement;

    if (!block) return null;

    // Common heading selectors in footer blocks
    var heading =
      block.querySelector('.section-footer__title') ||
      block.querySelector('h2,h3,h4') ||
      block.querySelector('[class*="title"],[class*="heading"]');

    if (!heading) return null;

    var text = normalizeText(heading.textContent);
    if (!text) return null;

    return heading;
  }

  function labelNav(navEl, fallbackIndex) {
    if (!navEl) return;

    // If already uniquely labeled via aria-labelledby, keep it
    var labelledby = (navEl.getAttribute('aria-labelledby') || '').trim();
    if (labelledby) return;

    // If aria-label exists but is generic, replace it
    var ariaLabel = normalizeText(navEl.getAttribute('aria-label'));
    var isGeneric = !ariaLabel || ariaLabel.toLowerCase() === 'secondary' || ariaLabel.toLowerCase() === 'navigation';

    var heading = findBlockHeading(navEl);
    if (heading) {
      var hid = ensureId(heading, 'footer-nav-label');
      navEl.setAttribute('aria-labelledby', hid);
      if (isGeneric && navEl.hasAttribute('aria-label')) navEl.removeAttribute('aria-label');
      return;
    }

    // Fallback: assign a unique aria-label
    if (isGeneric) {
      navEl.setAttribute('aria-label', 'Footer navigation ' + (fallbackIndex + 1));
    } else {
      // It has a specific label already, leave it
    }
  }

  function run() {
    var navs = findFooterNavs();
    for (var i = 0; i < navs.length; i++) labelNav(navs[i], i);
  }

  function boot() {
    run();

    // Some themes/app blocks hydrate late
    var tries = 0;
    var maxTries = 20;
    var timer = setInterval(function () {
      tries++;
      run();
      if (tries >= maxTries) clearInterval(timer);
    }, 500);

    var mo = new MutationObserver(function () { run(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* A11y patch: ensure navigation landmarks have unique labels sitewide */
(function () {
  'use strict';

  function normalizeText(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  function inEl(el, selector) {
    return !!(el && el.closest && el.closest(selector));
  }

  function labelForNav(nav, indexWithinGroup) {
    // Header
    if (inEl(nav, 'header, .site-header, [data-section-type*="header"], [id*="__header"]')) {
      return indexWithinGroup === 0 ? 'Primary navigation' : 'Header navigation ' + (indexWithinGroup + 1);
    }

    // Footer
    if (inEl(nav, 'footer, [id*="__footer"]')) {
      return indexWithinGroup === 0 ? 'Footer navigation' : 'Footer navigation ' + (indexWithinGroup + 1);
    }

    // Common mobile drawer / menu containers
    if (
      inEl(nav, '.drawer, .mobile-nav, .mobile-menu, .header-drawer, .nav-drawer, [class*="drawer"], [class*="mobile"]')
    ) {
      return indexWithinGroup === 0 ? 'Mobile navigation' : 'Mobile navigation ' + (indexWithinGroup + 1);
    }

    // Default
    return indexWithinGroup === 0 ? 'Site navigation' : 'Site navigation ' + (indexWithinGroup + 1);
  }

  function run() {
    var navs = Array.from(document.querySelectorAll('nav,[role="navigation"]'));

    // Group by aria-label value
    var map = {};
    navs.forEach(function (n) {
      var label = normalizeText(n.getAttribute('aria-label'));
      if (!label) return;

      var key = label.toLowerCase();
      map[key] = map[key] || [];
      map[key].push(n);
    });

    Object.keys(map).forEach(function (key) {
      var group = map[key];
      if (group.length <= 1) return;

      // Only fix duplicates that are generic and likely reused
      var isGeneric =
        key === 'primary' ||
        key === 'secondary' ||
        key === 'navigation' ||
        key === 'menu';

      if (!isGeneric) return;

      for (var i = 0; i < group.length; i++) {
        var nav = group[i];

        // Prefer aria-labelledby if already present
        if (normalizeText(nav.getAttribute('aria-labelledby'))) continue;

        nav.setAttribute('aria-label', labelForNav(nav, i));
      }
    });
  }

  function boot() {
    run();

    // Retry for late-rendered menus
    var tries = 0;
    var maxTries = 20;
    var timer = setInterval(function () {
      tries++;
      run();
      if (tries >= maxTries) clearInterval(timer);
    }, 500);

    var mo = new MutationObserver(function () { run(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Patch: make carousel prev/next controls keyboard tabbable */
(function () {
  'use strict';

  function fixCarouselNav(root) {
    var scope = root || document;

    // Match the Symmetry-style carousel nav anchors
    var btns = scope.querySelectorAll('a.image-page-button[tabindex="-1"]');

    for (var i = 0; i < btns.length; i++) {
      var a = btns[i];

      // Only change controls that are meant to be interactive
      // (aria-label is present in your example: "Previous")
      if (!a.getAttribute('aria-label')) continue;

      a.setAttribute('tabindex', '0');

      // If it is being used as a button control, make Space activate it
      if (!a.__f52ymmSpaceBound) {
        a.__f52ymmSpaceBound = true;
        a.addEventListener('keydown', function (e) {
          var key = e.key || e.code;

          // Space should trigger like a button
          if (key === ' ' || key === 'Spacebar' || key === 'Space') {
            e.preventDefault();
            this.click();
          }
        });
      }
    }
  }

  function boot() {
    fixCarouselNav(document);

    // Watch for carousels that mount after page load
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n && n.nodeType === 1) fixCarouselNav(n);
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  'use strict';

  function enhanceHoverOnlyArrows(root) {
    var scope = root || document;

    // Targets the arrows that are currently removed from tab order
    var arrows = scope.querySelectorAll('a.image-page-button[tabindex="-1"]');

    for (var i = 0; i < arrows.length; i++) {
      var a = arrows[i];

      // Keep scope tight, only touch the controls that look like real nav
      var label = a.getAttribute('aria-label') || '';
      if (!label) continue;

      // Make tabbable
      a.setAttribute('tabindex', '0');

      // Space activates like a button
      if (!a.__f52SpaceBound) {
        a.__f52SpaceBound = true;
        a.addEventListener('keydown', function (e) {
          var k = e.key || e.code;
          if (k === ' ' || k === 'Spacebar' || k === 'Space') {
            e.preventDefault();
            this.click();
          }
        });
      }
    }
  }

  function boot() {
    enhanceHoverOnlyArrows(document);

    // Re-run when product grid rerenders (filters, infinite scroll, etc.)
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n && n.nodeType === 1) enhanceHoverOnlyArrows(n);
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  'use strict';

  function lockDecorativeVideos(root) {
    var scope = root || document;

    // Target your collection header videos (adjust selector if needed)
    var vids = scope.querySelectorAll('video.f52-col-hero__video, #shopify-section-template--17685826568258__f52_collection_header_e4B4HE video');

    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];

      // If it is meant to be decorative, enforce the rules
      v.muted = true;
      v.defaultMuted = true;
      v.volume = 0;

      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('aria-hidden', 'true');
      v.setAttribute('tabindex', '-1');
      v.setAttribute('role', 'presentation');
      v.removeAttribute('controls');

      // Prevent later scripts from enabling audio
      if (!v.__f52MuteLocked) {
        v.__f52MuteLocked = true;

        v.addEventListener('volumechange', function () {
          if (!this.muted || this.volume !== 0) {
            this.muted = true;
            this.defaultMuted = true;
            this.volume = 0;
            this.setAttribute('muted', '');
          }
        });
      }
    }
  }

  function boot() {
    lockDecorativeVideos(document);

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n && n.nodeType === 1) lockDecorativeVideos(n);
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    var selector =
      '#section-id-template--17685826961474__background_video_Kabw9D video';

    var video = document.querySelector(selector);
    if (!video) return;

    // Stop if captions already exist
    if (video.querySelector('track[kind="captions"], track[kind="subtitles"]')) {
      return;
    }

    var track = document.createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    track.default = true;
    track.src = '/cdn/shop/t/64/assets/home-hero-captions.vtt';

    video.appendChild(track);
  });
})();

(function () {
  function disableCaptions(video) {
    try {
      if (!video || !video.textTracks) return;
      for (var i = 0; i < video.textTracks.length; i++) {
        video.textTracks[i].mode = 'disabled';
      }
    } catch (e) {}
  }

  function run() {
    var videos = document.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      disableCaptions(videos[i]);

      // Also disable again when playback starts
      videos[i].addEventListener('play', function () {
        disableCaptions(this);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Catch deferred-media swaps
  setTimeout(run, 500);
  setTimeout(run, 1500);
})();

(function () {
  function isRsrFitmentGuidePage() {
    return window.location && window.location.pathname === '/pages/rsr-fitment-guide';
  }

  function markShogunImagesDecorative(root) {
    if (!isRsrFitmentGuidePage()) return;

    var scope = root || document;

    // Shogun images often have class="shogun-image"
    var imgs = scope.querySelectorAll('img.shogun-image');

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];

      // If alt is missing, set decorative alt
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
      }

      // If alt exists but is null-ish, normalize
      if (img.getAttribute('alt') == null) {
        img.setAttribute('alt', '');
      }
    }
  }

  function init() {
    if (!isRsrFitmentGuidePage()) return;

    // Initial pass
    markShogunImagesDecorative(document);

    // Watch for Shogun late-load DOM injection
    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.addedNodes && m.addedNodes.length) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var node = m.addedNodes[j];
              if (node && node.nodeType === 1) {
                markShogunImagesDecorative(node);
              }
            }
          }
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function addHiddenLabelToModelButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('button.product-media__model-play-btn, button.product-media__model-play-btn.js-load-media');

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];

      // Skip if we already added it
      if (btn.querySelector('.sr-only, .visually-hidden, .f52-a11y-label')) continue;

      // Use existing aria-label, fall back to generic
      var label = btn.getAttribute('aria-label') || 'Play 3D viewer';

      var span = document.createElement('span');
      span.className = 'visually-hidden f52-a11y-label';
      span.textContent = label;

      btn.appendChild(span);
    }
  }

  function init() {
    addHiddenLabelToModelButtons(document);

    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.addedNodes && m.addedNodes.length) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var node = m.addedNodes[j];
              if (node && node.nodeType === 1) addHiddenLabelToModelButtons(node);
            }
          }
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function hasName(el) {
    if (!el) return false;
    if (el.hasAttribute('aria-label')) return true;
    if (el.hasAttribute('aria-labelledby')) return true;
    return (el.textContent || '').trim().length > 0;
  }

  function patchSvg(svg) {
    if (!svg || svg.tagName !== 'SVG') return;
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('role', 'presentation');
  }

  function scan(root) {
    var scope = root || document;
    var svgs = scope.querySelectorAll('svg');

    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      var control = svg.closest('a, button');

      // Only touch SVGs inside named controls
      if (!control || !hasName(control)) continue;

      patchSvg(svg);
    }
  }

  function init() {
    scan(document);

    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (!m.addedNodes) continue;

          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node && node.nodeType === 1) scan(node);
          }
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function normText(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  function hasAccessibleName(el) {
    if (!el) return false;
    if (el.getAttribute("aria-label")) return true;
    if (el.getAttribute("aria-labelledby")) return true;
    return normText(el.textContent).length > 0;
  }

  function labelFromHref(href) {
    if (!href) return "";
    try {
      var url = new URL(href, window.location.origin);
      var host = (url.hostname || "").replace(/^www\./, "").toLowerCase();

      // Brand-specific helpers (add more as you find them)
      if (host.includes("sparcousa.com")) return "Visit Sparco USA";
      if (host.includes("kw")) return ""; // leave empty unless you want to force it
      if (host.includes("thule")) return "Visit Thule";
      if (host.includes("r1concepts")) return "Visit R1 Concepts";

      // Generic: use host as label
      if (host) return "Visit " + host;
    } catch (e) {}
    return "";
  }

  function labelFromNearby(a) {
    if (!a) return "";

    // Shogun often has small caption text near the image
    var wrap =
      a.closest(".shg-box, .shg-item, .shg-c, .shogun-root, [class*='shg-']") || a.parentElement;

    if (!wrap) return "";

    var candidates = wrap.querySelectorAll(
      ".shg-rich-text, .shg-text, [class*='caption'], [class*='label'], p, small"
    );

    for (var i = 0; i < candidates.length; i++) {
      var t = normText(candidates[i].textContent);
      if (t && t.length <= 80) return t;
    }

    return "";
  }

  function patchShogunImageLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;

    var links = scope.querySelectorAll("a.shogun-image-link, a[class*='shogun-image-link']");
    for (var i = 0; i < links.length; i++) {
      var a = links[i];

      // Keep target=_blank safe
      if (a.getAttribute("target") === "_blank") {
        var rel = normText(a.getAttribute("rel"));
        if (!/noopener/i.test(rel) || !/noreferrer/i.test(rel)) {
          var nextRel = (rel ? rel + " " : "") + "noopener noreferrer";
          a.setAttribute("rel", normText(nextRel));
        }
      }

      // If it already has a name, do nothing
      if (hasAccessibleName(a)) continue;

      var img = a.querySelector("img");
      var imgAlt = img ? normText(img.getAttribute("alt")) : "";

      // Build a label
      var label = "";
      if (imgAlt) {
        // Better than nothing, but often alt is just a filename
        label = imgAlt;
      } else {
        label = labelFromNearby(a) || labelFromHref(a.getAttribute("href"));
      }

      // Last fallback
      if (!label) label = "External link";

      a.setAttribute("aria-label", label);

      // If image is inside and has no alt, set alt too
      if (img && !imgAlt) {
        // For logos, alt should usually be the brand name, not “External link”
        var cleanAlt = label
          .replace(/^Visit\s+/i, "")
          .replace(/\s+website$/i, "")
          .trim();

        img.setAttribute("alt", cleanAlt || "Logo");
      }
    }
  }

  function init() {
    patchShogunImageLinks(document);

    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (!m.addedNodes) continue;
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node && node.nodeType === 1) patchShogunImageLinks(node);
          }
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  onReady(init);
})();

(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function normText(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  function controlHasName(el) {
    if (!el) return false;
    if (el.getAttribute("aria-label")) return true;
    if (el.getAttribute("aria-labelledby")) return true;
    return normText(el.textContent).length > 0;
  }

  function svgHasOwnName(svg) {
    if (!svg) return false;
    if (svg.getAttribute("aria-label")) return true;
    if (svg.getAttribute("aria-labelledby")) return true;

    // If it has a <title> or <desc>, it may be intended as meaningful
    var hasTitle = svg.querySelector("title");
    var hasDesc = svg.querySelector("desc");
    return !!(hasTitle || hasDesc);
  }

  function makeSvgDecorative(svg) {
    if (!svg) return;

    // If SVG is intentionally exposed as an image, do not override it
    var role = (svg.getAttribute("role") || "").toLowerCase();
    if (role === "img") return;

    // If it already has its own accessible name, leave it alone
    if (svgHasOwnName(svg)) return;

    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    svg.setAttribute("role", "presentation");
  }

  function patchIconSvgs(root) {
    var scope = root && root.querySelectorAll ? root : document;

    // Any svg inside an interactive control
    var svgs = scope.querySelectorAll("a svg, button svg");

    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      var control = svg.closest("a, button");
      if (!control) continue;

      // Only hide the SVG if the control already has a real name
      if (!controlHasName(control)) continue;

      makeSvgDecorative(svg);
    }
  }

  function init() {
    patchIconSvgs(document);

    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (!m.addedNodes) continue;
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node && node.nodeType === 1) patchIconSvgs(node);
          }
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  onReady(init);
})();
